'use strict';

var shams = require('./shams.js');

var origSymbol = global.Symbol;
var hasSymbolSham = shams;

var hasSymbols = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

module.exports = hasSymbols;
